import { useEffect } from "react";
import * as Sentry from "@sentry/react";

/** List of routes (or partial route strings) to ignore. */
const IGNORE_ROUTES = [
  "/find-portfolio-company",
  "/auth-invite-info"
  // Add more if needed
];

/** List of error substrings to ignore in the event message. */
const IGNORE_PATTERNS = ["Request failed with status code 401", "Unauthorized", "Failed to fetch", "Network Error"];

export function useSentry() {
  useEffect(() => {
    if (!Sentry.getClient()) {
      const viteSentry = import.meta.env.VITE_SENTRY_URL;

      Sentry.init({
        dsn: viteSentry,

        // Config for Sentry Replays
        integrations: [
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false
          })
        ],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,

        ignoreErrors: [
          "Request failed with status code 401", // e.g. Axios-based 401
          "401 Unauthorized",
          "Failed to fetch",
          "NetworkError",
          "ChunkLoadError",
          "Load failed"
        ],

        beforeSend: function (event, hint) {
          const exception = event?.exception?.values?.[0];
          if (exception) {
            // 1) Check if the event's request URL matches any ignore route
            const requestUrl = event.request?.url;
            if (requestUrl) {
              const shouldIgnoreRoute = IGNORE_ROUTES.some((route) => requestUrl.includes(route));
              if (shouldIgnoreRoute) {
                return null;
              }
            }

            // 2) Check if the exception message matches any ignore pattern
            const message = exception.value;
            if (message) {
              const shouldIgnoreError = IGNORE_PATTERNS.some((pattern) => message.includes(pattern));
              if (shouldIgnoreError) {
                return null;
              }
            }
          }

          return event;
        }
      });
    }
  }, []);
}
